import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useStore from "store/hook";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import api from "store/api/api";
import { Collapse, DialogActions, Typography } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import CircularLoader from "./Loader";
import { toast } from "react-toastify";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { FaPlus } from "react-icons/fa";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SelectInspection from "./SelectInspection";
import { useParams } from "react-router-dom";
import formatStringWithSpaces from "services/stringconverter";
import DateTimePicker from "layouts/updateInspection/components/DateTimePicker";
import getDateFromSeconds from "services/getDate";
import CancelIcon from "@mui/icons-material/Cancel";

export default function AddDeficiency() {
  const { id } = useParams();
  const { store, setDialogue } = useStore();
  const [loading, setLoading] = React.useState(false);
  const [form, setForm] = React.useState({
    deficiencyInspectionId: "",
    deficiencyDate: "",
    inspectionType: "",
    location: "",
    listOfDeficiencies: [],
    correctedInspectionId: "",
    correctedDate: "",
    deficiencyInspectionData: {
      inspectionNumber: "",
      temprature: "",
      weatherCondition: "",
      deficienciesFound: [],
    },
    correctedInspectionData: {
      inspectionNumber: "",
      temprature: "",
      weatherCondition: "",
      deficienciesFound: [],
    },
  });

  const [deficiencyText, setDeficiencyText] = React.useState("");
  const [updatedData, setUpdatedData] = React.useState({
    index: "",
    isEdit: false,
  });

  const {
    isOpen = false,
    action,
    projectId,
    deficiencylogId,
    isEdit,
  } = store?.app?.dialogs?.AddDeficiency || {};
  const { success } = store?.app?.dialogs?.isSuccess || {};

  const handleClose = () => {
    setForm({
      deficiencyInspectionId: "",
      deficiencyDate: "",
      inspectionType: "",
      location: "",
      listOfDeficiencies: [],
      correctedInspectionId: "",
      correctedDate: "",
      deficiencyInspectionData: {
        inspectionNumber: "",
        temprature: "",
        weatherCondition: "",
        deficienciesFound: [],
      },
      correctedInspectionData: {
        inspectionNumber: "",
        temprature: "",
        weatherCondition: "",
        deficienciesFound: [],
      },
    });
    setDeficiencyText("");
    setDialogue({
      type: "AddDeficiency",
      isOpen: false,
      isEdit: false,
      inspectionId: "",
      deficiencylogId: "",
      projectId: "",
    });
  };

  const handleAddDeficiecyList = () => {
    if (deficiencyText == "") {
      toast.error("Please enter the text in add deficiency");
    } else {
      setForm((prev) => ({
        ...prev,
        listOfDeficiencies: [
          ...(prev.listOfDeficiencies || []),
          deficiencyText,
        ],
      }));
      setDeficiencyText("");
    }
  };

  const handleDeleteDeficiency = (index) => {
    setForm((prev) => ({
      ...prev,
      listOfDeficiencies: prev?.listOfDeficiencies?.filter(
        (item, i) => i !== index
      ),
    }));
  };


  const handleUpdateDeficiency = () => {
    setForm((prev) => ({
      ...prev,
      listOfDeficiencies: prev?.listOfDeficiencies?.map((item, index) =>
        index == updatedData?.index ? deficiencyText : item
      ),
    }));

    setDeficiencyText("");
    setUpdatedData({
      index: "",
      isEdit: false,
    });
  };

  const handleAddDeficiencyLog = async () => {
    setLoading(true);

    if (form?.deficiencyInspectionId == "") {
      toast.error("Please add the deficiency inspection");
      setLoading(false);
      return;
    }

    if (form?.deficiencyDate == "") {
      toast.error("Please add the deficiency data");
      setLoading(false);
      return;
    }

    if (form?.inspectionType == "") {
      toast.error("Please add the inspection Type");
      setLoading(false);
      return;
    }

    if (form?.listOfDeficiencies.length <= 0) {
      toast.error("Please add the deficiency list");
      setLoading(false);
      return;
    }

    try {
      let data;
      isEdit
        ? (data = {
            deficiencyLogId: deficiencylogId,
            list_of_dependencies: form?.listOfDeficiencies,
            deficiency_inspection_id: form?.deficiencyInspectionId || "",
            inspection_type: form?.inspectionType,
            location: form?.location,
            corrected_inspection_id: form?.correctedInspectionId || "",
            deficiency_date: form?.deficiencyDate,
            corrected_date: form?.correctedDate,
          })
        : (data = {
            list_of_dependencies: form?.listOfDeficiencies,
            deficiency_inspection_id: form?.deficiencyInspectionId,
            inspection_type: form?.inspectionType,
            location: form?.location,
            corrected_inspection_id: form?.correctedInspectionId,
            projectId: action == "addProjectlog" ? id : projectId,
            insepctionId: action == "addInspectionlog" ? id : "",
            deficiency_date: form?.deficiencyDate,
            corrected_date: form?.correctedDate,
          });

      const response = isEdit
        ? await api.editDeifciencylog(data)
        : await api.addDeficiencylog(data);

      if (response.status == 1) {
        setDialogue({
          type: "isSuccess",
          success: !success,
        });
        toast.success(
          formatStringWithSpaces(response?.message) ||
            (isEdit
              ? "Deficiency log updated successfully"
              : "Deficieny log added successfully")
        );
        handleClose();
      } else {
        toast.error(
          formatStringWithSpaces(response?.message) ||
            (isEdit
              ? "Error in updating deficiency log"
              : "Error in add deficiency log")
        );
      }
    } catch (error) {
      console.error("Errot  in add deficiency log");
    } finally {
      setLoading(false);
    }
  };

  const fetchDeficiencylogDetails = async () => {
    try {
      setLoading(true);
      const response = await api.getDeficiencylogDetails({
        deficiencyLogId: deficiencylogId,
      });

      const data = response?.data;

      if (response?.status == 1 && isEdit) {
        setForm({
          deficiencyInspectionId:
            data?.deficiencyLogData?.deficiency_inspection_id,
          deficiencyDate: data?.deficiencyLogData?.deficiency_date,
          inspectionType: data?.deficiencyLogData?.inspection_type,
          location: data?.deficiencyLogData?.location,
          listOfDeficiencies: data?.deficiencyLogData?.list_of_dependencies,
          correctedInspectionId:
            data?.deficiencyLogData?.corrected_inspection_id,
          correctedDate: data?.deficiencyLogData?.corrected_date,
          deficiencyInspectionData: {
            inspectionNumber: data?.deficiencyInspectionData?.inspection_number,
            temprature: data?.deficiencyInspectionData?.temperature,
            weatherCondition: data?.deficiencyInspectionData?.weather_condition,
            deficienciesFound:
              data?.deficiencyInspectionData?.deficiencies_found,
          },
          correctedInspectionData: {
            inspectionNumber: data?.correctedInspectionData?.inspection_number,
            temprature: data?.correctedInspectionData?.temperature,
            weatherCondition: data?.correctedInspectionData?.weather_condition,
            deficienciesFound:
              data?.correctedInspectionData?.deficiencies_found,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching project detail:", error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (isEdit) {
      fetchDeficiencylogDetails();
    }
  }, [isOpen, deficiencylogId]);

  const handleUnselectCorrectedInspection = () => {
    setForm((prev) => ({
      ...prev,
      correctedInspectionId: "",
      correctedDate: "",
      correctedInspectionData: {
        inspectionNumber: "",
        temprature: "",
        weatherCondition: "",
        deficienciesFound: [],
      },
    }));
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        aria-labelledby="select-inspector-dialog"
        sx={{
          "& .MuiDialog-paper": {
            margin: 2,
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "white.main",
            padding: "18px 24px !important",
          }}
        >
          <SoftBox display="flex" alignItems="center" justifyContent="center">
            <SoftTypography
              color="lightBlack"
              fontSize="26px"
              fontWeight="bold"
              sx={{ color: "#212121" }}
            >
              Add Deficiency{" "}
            </SoftTypography>
          </SoftBox>

          <SoftBox
            width="100%"
            display="flex"
            alignItems="start"
            justifyContent="center"
            flexDirection="column"
            gap={3}
          >
            {/* Select Deficiency Inspection */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                width="100%"
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Defeciency Inspection
                </SoftTypography>

                <SoftBox
                  display="flex"
                  gap="2px"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    setDialogue({
                      type: "selectInspection",
                      isOpen: true,
                      inspectionId: "",
                      action: "deficiencyInspection",
                    })
                  }
                >
                  <SoftTypography
                    color="primary"
                    fontSize="16px"
                    fontWeight="medium"
                  >
                    Choose Inspection
                  </SoftTypography>

                  <SoftTypography color="primary" sx={{ mt: "6px" }}>
                    <ChevronRightIcon
                      sx={{
                        width: 20,
                        height: 20,
                      }}
                    />
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
              {form?.deficiencyInspectionId !== "" &&
              form?.deficiencyInspectionId !== undefined ? (
                <SoftBox
                  width="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <SoftBox
                    borderRadius="6px"
                    padding="10px"
                    width="100%"
                    backgroundColor="#F1F4F8"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <SoftBox
                      display="flex"
                      width="100%"
                      sx={{
                        flexDirection: { xs: "column", sm: "column" },
                        gap: { xs: "2px", sm: "5px" },
                      }}
                    >
                      <SoftBox display="flex" gap="3px" width="100%">
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="medium"
                        >
                          Inspection Number :
                        </SoftTypography>
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="regular"
                        >
                          {form?.deficiencyInspectionData?.inspectionNumber}
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox>
                        <SoftTypography
                          color="primary"
                          fontSize="14px"
                          fontWeight="normal"
                        >
                          {form?.deficiencyInspectionData?.deficienciesFound ===
                          "no"
                            ? "There is no deficiencies found."
                            : form?.deficiencyInspectionData
                                ?.deficienciesFound === "yes"
                            ? "There is deficiencies found"
                            : formatStringWithSpaces(
                                form?.deficiencyInspectionData?.deficienciesFound.join(
                                  ", "
                                )
                              )}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <SoftBox
                      display="flex"
                      justifyContent="end"
                      gap="3px"
                      width="100%"
                      sx={{ padding: { sm: "5px", xs: "0px" } }}
                    >
                      <SoftTypography
                        color="primary"
                        fontSize="16px"
                        fontWeight="regular"
                      >
                        {form?.deficiencyInspectionData?.weatherCondition},{" "}
                        {form?.deficiencyInspectionData?.temprature}°F
                      </SoftTypography>
                      <SoftTypography
                        color="primary"
                        fontSize="16px"
                        fontWeight="medium"
                      >
                        : Weather
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ) : (
                <SoftBox width="100%">
                  <SoftBox
                    borderRadius="6px"
                    padding="10px"
                    width="100%"
                    height="70px"
                    backgroundColor="#F1F4F8"
                  >
                    <SoftTypography
                      color="text"
                      fontSize="14px"
                      fontWeight="normal"
                    >
                      You haven't selected inspection detail at the moment.
                      Please choose inspection to import data.
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}
            </SoftBox>

            {/* Deficiency Date */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Deficiency Date
                </SoftTypography>
              </SoftBox>

              <SoftBox
                onClick={() =>
                  setDialogue({
                    type: "openDateTimePicker",
                    isOpen: true,
                    action: "deficiencydate",
                  })
                }
              >
                <SoftInput
                  name="location"
                  placeholder="Choose Deficiency Date"
                  multiline
                  value={
                    form?.deficiencyDate
                      ? getDateFromSeconds(form?.deficiencyDate)
                      : ""
                  }
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input": {
                      color: "#02255B", // Actual input text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* Inspection Type */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Inspection Type
                </SoftTypography>
              </SoftBox>

              <SoftBox>
                <SoftInput
                  name="inspectiontype"
                  placeholder="Enter Inspection Type"
                  value={form.inspectionType}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      inspectionType: e.target.value,
                    }))
                  }
                  multiline
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input": {
                      color: "#02255B", // Actual input text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* Location */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Location
                </SoftTypography>
              </SoftBox>

              <SoftBox>
                <SoftInput
                  name="inspectiontype"
                  placeholder="Enter the location"
                  value={form?.location}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                  multiline
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input": {
                      color: "#02255B", // Actual input text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>

            {/* List Of deficiencies */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  List Of Deficiencies
                </SoftTypography>
              </SoftBox>

              {
                <SoftBox>
                  {form?.listOfDeficiencies?.length > 0 &&
                    form?.listOfDeficiencies?.map((deficiency, index) => (
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          backgroundColor: "#F1F4F8",
                          borderRadius: "6px",
                          padding: "0px 8px",
                          marginBottom: "4px",
                          overflowX: "auto",
                          overflowY: "hidden",
                          whiteSpace: "nowrap",
                          scrollbarWidth: "none",
                          "&::-webkit-scrollbar": { display: "none" },
                        }}
                      >
                        <SoftBox
                          display="flex"
                          flexDirection="column"
                          color="primary"
                        >
                          <SoftTypography
                            fontSize="14px"
                            color="primary"
                            fontWeight="normal"
                          >
                            {deficiency}
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          pt={1}
                          display="felx"
                          alignItems="center"
                          justifyContent="center"
                          gap={2}
                        >
                          <DeleteIcon
                            sx={{
                              cursor: "pointer",
                              width: "20px",
                              height: "20px",
                              color: "error.main",
                            }}
                            onClick={() => handleDeleteDeficiency(index)}
                          />

                          <EditIcon
                            sx={{
                              cursor: "pointer",
                              width: "20px",
                              height: "20px",
                              color: "primary.main",
                              padding: "2px",
                              borderRadius: "50%",
                            }}
                            onClick={() => {
                              setUpdatedData((prev) => ({
                                ...prev,
                                index: index,
                                isEdit: true,
                              }));
                              setDeficiencyText(deficiency);
                            }}
                          />
                        </SoftBox>
                      </SoftBox>
                    ))}
                </SoftBox>
              }

              <SoftBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
              >
                <SoftInput
                  name="location"
                  placeholder="Add a Deficiency"
                  value={deficiencyText}
                  onChange={(e) => setDeficiencyText(e?.target?.value)}
                  multiline
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input": {
                      color: "#02255B", // Actual input text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />

                <SoftBox>
                  <SoftButton
                    variant="contained"
                    color="info"
                    sx={{
                      padding: "7px 12px",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                    onClick={
                      updatedData?.isEdit
                        ? handleUpdateDeficiency
                        : handleAddDeficiecyList
                    }
                  >
                    {updatedData?.isEdit ? "Update" : "Add"}{" "}
                    <FaPlus size={14} />
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            {/* Select Corrected Inspection */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                width="100%"
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Corrected Inspection
                </SoftTypography>

                <SoftBox
                  display="flex"
                  gap="2px"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    setDialogue({
                      type: "selectInspection",
                      isOpen: true,
                      inspectionId: "",
                      action: "correctedInspection",
                    })
                  }
                >
                  <SoftTypography
                    color="primary"
                    fontSize="16px"
                    fontWeight="medium"
                  >
                    Choose Inspection
                  </SoftTypography>

                  <SoftTypography color="primary" sx={{ mt: "6px" }}>
                    <ChevronRightIcon
                      sx={{
                        width: 20,
                        height: 20,
                      }}
                    />
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
              {form?.correctedInspectionId !== "" &&
              form?.correctedInspectionId !== undefined ? (
                <SoftBox
                  width="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <SoftBox
                    borderRadius="6px"
                    padding="10px"
                    width="100%"
                    backgroundColor="#F1F4F8"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <SoftBox
                      display="flex"
                      width="100%"
                      sx={{
                        flexDirection: { xs: "column", sm: "column" },
                        gap: { xs: "2px", sm: "5px" },
                      }}
                    >
                      <SoftBox display="flex" gap="3px" width="100%">
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="medium"
                        >
                          Inspection Number :
                        </SoftTypography>
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="regular"
                        >
                          {form?.correctedInspectionData?.inspectionNumber}
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox>
                        <SoftTypography
                          color="primary"
                          fontSize="14px"
                          fontWeight="normal"
                        >
                          {form?.correctedInspectionData?.deficienciesFound ===
                          "no"
                            ? "There is no deficiencies found."
                            : form?.deficiencyInspectionData
                                ?.deficienciesFound === "yes"
                            ? "There is deficiencies found"
                            : formatStringWithSpaces(
                                form?.correctedInspectionData?.deficienciesFound?.join(
                                  ", "
                                )
                              )}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <SoftBox
                      display="flex"
                      width="100%"
                      sx={{
                        flexDirection: { xs: "column", sm: "column" },
                        gap: { xs: "2px", sm: "5px" },
                      }}
                    >
                      <SoftBox
                        display="flex"
                        justifyContent="end"
                        gap="3px"
                        width="100%"
                      >
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="regular"
                        >
                          {form?.correctedInspectionData?.weatherCondition},{" "}
                          {form?.correctedInspectionData?.temprature}°F
                        </SoftTypography>
                        <SoftTypography
                          color="primary"
                          fontSize="16px"
                          fontWeight="medium"
                        >
                          : Weather
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox
                        onClick={handleUnselectCorrectedInspection}
                        display="flex"
                        justifyContent="end"
                        gap="3px"
                        alignItems="center"
                        sx={{
                          cursor: "pointer",
                        }}
                      >
                        <SoftTypography
                          color="error"
                          fontSize="16px"
                          fontWeight="regular"
                        >
                          Clear Inspection
                        </SoftTypography>

                        <CancelIcon
                          sx={{
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            color: "error.main",
                          }}
                        />
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ) : (
                <SoftBox width="100%">
                  <SoftBox
                    borderRadius="6px"
                    padding="10px"
                    width="100%"
                    height="70px"
                    backgroundColor="#F1F4F8"
                  >
                    <SoftTypography
                      color="text"
                      fontSize="14px"
                      fontWeight="normal"
                    >
                      You haven't selected inspection detail at the moment.
                      Please choose inspection to import data.
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}
            </SoftBox>

            {/* Corrected Date */}
            <SoftBox width="100%">
              <SoftBox
                sx={{
                  backgroundColor: "white.main",
                  overflowY: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <SoftTypography
                  color="lightBlack"
                  fontSize="18px"
                  fontWeight="bold"
                  sx={{ color: "#212121" }}
                >
                  Corrected Date
                </SoftTypography>
              </SoftBox>

              <SoftBox
                onClick={() =>
                  setDialogue({
                    type: "openDateTimePicker",
                    isOpen: true,
                    action: "correctedDate",
                  })
                }
              >
                <SoftInput
                  name="location"
                  placeholder="Choose Corrected Date"
                  multiline
                  value={
                    form?.correctedDate
                      ? getDateFromSeconds(form?.correctedDate)
                      : ""
                  }
                  sx={{
                    padding: "14px 12px",
                    "& .MuiInputBase-input": {
                      color: "#02255B", // Actual input text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#737373 !important",
                      fontSize: "15px",
                      opacity: 1,
                    },
                  }}
                />
              </SoftBox>
            </SoftBox>
          </SoftBox>

          {/* Action Buttons */}
          <SoftBox mt={2}>
            <DialogActions
              sx={{
                justifyContent: "center",
                flexDirection: "column",
                gap: 3,
                padding: "0px",
              }}
            >
              <SoftButton
                variant="gradient"
                color="primary"
                sx={{
                  width: "45%",
                  padding: "14px 24px",
                  fontSize: "16px",
                }}
                onClick={handleAddDeficiencyLog}
              >
                {loading == true ? <CircularLoader type="small" /> : "Save"}
              </SoftButton>
              <SoftTypography
                fontSize="16px"
                fontWeight="bold"
                align="center"
                color="primary"
                sx={{ margin: "0px !important", cursor: "pointer" }}
                onClick={handleClose}
              >
                Cancel
              </SoftTypography>
            </DialogActions>
          </SoftBox>
        </DialogContent>
      </Dialog>

      <SelectInspection projectid={projectId} form={form} setForm={setForm} />
      <DateTimePicker form={form} setForm={setForm} />
    </>
  );
}
